// Module
var code = `<!-- ko with: model -->
<!-- ko if: isVisible -->
<div class="svc-object-selector__content" data-bind="component: { name: 'sv-list', params: { model: list } }"></div>
<!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;